export class MedicalsSubData{
REPORT_NO:string;
REPORT_DATE:string;
PATIENT_ID:string;
OP_NO:string;
IP_NO:string;
NOCHARGE_FLAG:string;
TEMPLATE_NO:string;
WORKORDER_NO:string;
DOCTOR_CODE:string;
REQUEST_NO:string;
STATUS:string;
RPT_DATE: string;
DateOfBirth: string;
Gender: string;
MEDICAL_REPORT: string;
PatientName: string;
SponsorName: string;
DeptName: string;
SequenceNo: string;
CATEGORYNAME: string;
OPORIPNo: string;
DoctorName: string;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/model/medicalreport/MedicalsSubData.ts